module.exports = "/0e8d9e4c10ecc96ae93aaa2b69d940f1c8363bc3/fbca1281c2f4b02239d564167141c614.svg";